import { Component, OnInit, Inject, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbAppEvents, IrbModelsEvents} from '@irb-common/events';
import { ImportEquivalentsResultGridLayoutService } from './import-equivalents-result.grid-layout.service';
import { SecurityMasterService } from '../security-master/security-master.service';
import { IAlertDialogData } from '@irb/app.model'; //IREBAL-26684
import { IrbEditorsService } from '../../irb-editors/irb-editors.service'//IREBAL-26684

@Component({ standalone: false,
  selector: 'irb-import-equivalents-result-dialog',
  templateUrl: './import-equivalents-result-dialog.component.html',
  styleUrls: ['./import-equivalents-result-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ImportEquivalentsResultDialogComponent implements OnInit {
  grid: any;
  gridOptions: any;
  nonInventoried: any;
  unRecognized: any;
  isUiTest = false;
  updateStatusCount = 0; //IREBAL-26684
  progressTimer: any = null; //IREBAL-26684
  frameworkComponents: any;

  constructor(
    public dialogRef: MatDialogRef<ImportEquivalentsResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public as: AppService,
    private gls: ImportEquivalentsResultGridLayoutService,
    public securityMasterService:SecurityMasterService,
    public irbEditorsService: IrbEditorsService //IREBAL-26684
  ) {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  ngOnInit() {
    if (this.data) {
      if (this.data.NonInventoried) {
        this.nonInventoried = (this.data.NonInventoried.data && this.data.NonInventoried.data.length > 0);
      }
      if (this.data.unRecognized) {
        this.unRecognized = (this.data.unRecognized.data && this.data.unRecognized.data.length > 0);
      }
    }
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
  }

  //IREBAL-26684
  updateEquivalentsStatusCheckIntervalStart(statusId: any) {
    this.irbEditorsService.actionStatusCheck(statusId).subscribe((statusResponse: any) => {
      const response = statusResponse?.responseData;
      const reqStatus = response?.reqStatus?.trim().toUpperCase();

      if (reqStatus === 'FAILED') {
        this.actionStatusCheckFailed();
      }

      if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
        this.updateProgressBarStatus(statusId);
      }

      if (reqStatus === 'COMPLETED') {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'success',
          summary: 'Import Equivalents',
          detail: statusResponse.responseData.successRecCount + " security(ies) imported/updated. "
        });
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        if(this.progressTimer) clearTimeout(this.progressTimer);
        this.close();
      }
    }, () => {
      this.close();
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      if(this.progressTimer) clearTimeout(this.progressTimer);
    });
  }

  actionStatusCheckFailed() {
    this.close();
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    if(this.progressTimer) clearTimeout(this.progressTimer);
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dType: 'ERROR',
      dTitle: '',
      dProceedBtnLabel: '',
      msg: 'An error occurred processing your request.',
      onProceed: () => {
      }
    } as IAlertDialogData);
  }

  updateProgressBarStatus(statusId: any) {
    let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
    if (this.isUiTest)
      timeout = 0;
    this.updateStatusCount++;
    this.progressTimer = setTimeout(() => {
      this.updateEquivalentsStatusCheckIntervalStart(statusId);
    }, timeout);
  }

  completeImport() { 

    if(this.nonInventoried || this.unRecognized ){
      this.data.isAddToIrebal = true;
      this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_CATEGORY_SECURITIES, this.data);
    } else{
      //IREBAL-26684
      this.securityMasterService.updateEquivalentsAsync(this.data.validRecords).subscribe((data: any) => {
        if(this.progressTimer) clearTimeout(this.progressTimer);           
   
        if(data.responseStatus=== "SUCCESS") {        
          this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
          this.updateEquivalentsStatusCheckIntervalStart(data.responseUtilityMap.statusId);
        } else{
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error', 
            summary: 'Import Equivalents', 
            detail: " An error occurred processing your request."
          });
          this.close();
        }
      });
    }    
     
   

    this.close();

  }
}
